function parseQuestion(string) {
  return string
    .toLowerCase()
    .replace(/^\s+|\s+$|'/g, '')
    .replace(/\s+/g, '-')
}

function parseSection(string) {
  return string
    .replace(/[ &]/g, '')
}

function parse2UpperDevice(string) {
  if (string === 'orka_one') {
    return 'OrkaOne'
  } else if (string === 'orka_two') {
    return 'OrkaTwo'
  }
  return string
}

export { parse2UpperDevice, parseQuestion, parseSection }
